// extracted by mini-css-extract-plugin
export default {"container":"UjYCKlwcdvOpvn5o8l9c"};